<template>
    <div v-if="showReserveExchangeButton()" class="col-12 mt2">
      <div
      class="flex items-center justify-center"
      v-if="billetRef.isExchangePossible"
      >
      <span
      :class="[
        'btn-reserve large-text white-color black-bg py-small px3 pointer',
        { disabled: billetRef.remainingQuantity === 0 },
      ]"
        @click="goToTicketReservation()"
        >
        {{ canShowEchangeButton() ? "Échanger" : "Réserver" }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

const props = defineProps({
  billet: {
    type: Object,
  },
});

const store = useStore();
const router = useRouter();

const isInternalSession = computed(
  () => store.state.siteInfo.is_internal_session || null
);
const billetRef = ref(props.billet)

const showReserveExchangeButton = () => {
  if (!billetRef.value.order_contremarque && billetRef.value.contratReservable) {
    if (isInternalSession.value) {
      if (
        ["reloadable"].includes(billetRef.value.type) &&
        billetRef.value.remainingQuantity !== 0
      ) {
        return true;
      }
      return false;
    }
    if (!["single-entry"].includes(billetRef.value.type)) {
      if (["recurring"].includes(billetRef.value.type)) {
        return true;
      }
      if (
        ["reloadable"].includes(billetRef.value.type) &&
        billetRef.value.remainingQuantity !== 0
      ) {
        return true;
      }
      if (["single-session"].includes(billetRef.value.type) && billetRef.value.showSession) {
        return true;
      }
    }
  }
};

const canShowEchangeButton = () => {
  if (isInternalSession.value) {
    return billetRef.value.inscription
      ? false
      : ["single-session"].includes(billetRef.value.type);
  }
  return ["single-session"].includes(billetRef.value.type);
};

const goToTicketReservation = async () => {
  store.commit("resetCalendarDays");
  store.commit("setSelected", []);
  store.commit("setSession", null);
  store.commit("setSelectedActivity", []);
  store.commit("setSelectedActivityKey", null);
  router.push({
    name: "ActivitiesList",
    params: { billet_uuid: billetRef.value.uuid },
  });
};
</script>